<template>
    <el-dialog
        title="批量查询导出"
        :visible.sync="dialogVisible"
        width="600px"
        :before-close="handleClose"
    >
        <el-upload
            class="upload-demo"
            ref="upload"
            action=""
            :file-list="fileList"
            :auto-upload="false"
            :on-remove="handleRemove"
            :on-change="fileChange"
        >
            <el-button size="small" type="primary">上传</el-button>
        </el-upload>
        <el-collapse value="1" class="processSearchTotal-collapse">
            <el-collapse-item title="模板" name="1">
                <mExport
                    :url="templateExport.exportUrl"
                    :params="templateExport.exportParams"
                    :name="templateExport.exportName"
                    :exportFlag="templateExport.exportFlag"
                    :type="templateExport.type"
                    :listData="listData"
                    :linkFlag="true"
                    :titleText="templateExport.titleText"
                >
                </mExport>
            </el-collapse-item>
        </el-collapse>
        <span slot="footer" class="dialog-footer">
            <reportExport #default="{ submit }" reportCode="">
                <el-button
                    size="small"
                    @click="exportListFile(submit)"
                    type="primary"
                    >查询导出</el-button
                >
            </reportExport>
        </span>
    </el-dialog>
</template>

<script>
import { uploadProcess } from '../../../../../api/lcbsManagement.js';
import mExport from '../../../component/export';
import reportExport from '@/components/lots/reportExportPlugin';
const FIRE_SIZE = 1 * 1024 * 1024; // 文件大小1M
const EXPORT_API = '/api-sn/lbcs/domesticBarcodeFullProcess/export'; // 通用导出接口路径

export default {
    components: { mExport, reportExport },
    props: {
        listData: {
            type: Array,
            default: () => []
        },
        columnsParams: {
            type: [String, Array],
            default: () => []
        },
        isReadTheEnd: {
            type: String,
            default: () => '0'
        },
        isReadTheLogistics: {
            type: String,
            default: () => '0'
        },
        selectFlag: {
            type: String,
            default: () => '1'
        }
    },
    data() {
        return {
            listExport: {
                exportUrl: '/api-sn/lbcs/barcodeFullProcessTracking/export',
                exportName: this.$translate('lang.E3202101280016', {
                    defaultText: '条码全流程信息查询列表.xls'
                }),
                exportParams: {},
                titleText: this.$translate('lang.E3202101260010', {
                    defaultText: '导出Excel'
                }),
                exportFlag: 0
            },
            templateFlie: {},
            fileList: [],
            templateExport: {
                exportUrl:
                    '/api-sn/lbcs/barcodeFullProcessTracking/templates/download',
                exportName: this.$translate('lang.E3202101280017', {
                    defaultText: 'LBCS条码全流程批量查询模板.xlsx'
                }),
                exportParams: {},
                titleText: this.$translate('lang.E3202101260014', {
                    defaultText: '批量查询模板下载'
                }),
                exportFlag: 1,
                type: 'get'
            },
            dialogVisible: false
        };
    },
    methods: {
        open() {
            this.dialogVisible = true;
        },
        handleClose() {
            this.dialogVisible = false;
            this.templateFlie = {};
            this.listExport.exportFlag = 0;
            this.$refs.upload.clearFiles();
        },
        handleRemove(file) {
            this.templateFlie = {};
            this.$refs.upload.clearFiles();
        },
        fileChange(file, fileList) {
            if (fileList.length > 0) {
                this.fileList = [fileList[fileList.length - 1]];
            }
            const testmsg = file.name.substring(file.name.lastIndexOf('.') + 1);
            if (testmsg !== 'xlsx' && testmsg !== 'xls') {
                this.$message({
                    message: this.$translate('lang.EXC202407010001', {
                        defaultText: '表格上传类型不正确,仅支持上传xls，跟xlsx两种格式'
                    }),
                    type: 'warning'
                });
                this.$refs.upload.clearFiles();
                this.templateFlie = {};
                this.fileList = [];
            } else {
                this.templateFlie = file;
            }
        },
        exportListFile(submit) {
            if (!this.templateFlie.name) {
                this.$message.warning('请先上传文件');
                return;
            }
            if (this.templateFlie.size > FIRE_SIZE) {
                this.$message.warning('文件大小不得超过1024KB，请修改后上传！');
                return;
            }
            const form = new FormData();
            form.append('file', this.templateFlie.raw);
            if (this.isReadTheLogistics) {
                form.append('isReadTheLogistics', this.isReadTheLogistics);
            }
            if (this.isReadTheEnd) {
                form.append('isReadTheEnd', this.isReadTheEnd);
            }
            if (this.selectFlag) {
                form.append('selectFlag', this.selectFlag);
            }
            uploadProcess(form).then((res) => {
                if (res && +res.code === 0) {
                    const params = {
                        EXPORT_API,
                        barcodeBatchNo: res.data
                    };
                    if (this.columnsParams) {
                        params.columns = this.columnsParams;
                    }
                    if (this.isReadTheLogistics) {
                        params.isReadTheLogistics = this.isReadTheLogistics;
                    }
                    if (this.isReadTheEnd) {
                        params.isReadTheEnd = this.isReadTheEnd;
                    }
                    if (this.selectFlag) {
                        params.isReadTheEnd = this.selectFlag;
                    }
                    this.listExport.exportFlag = 1;
                    submit(params);
                    this.$homeRef.setGlobalEvaluateConfig('查询按钮');
                }
            });
        }
    }
};
</script>

<style lang="less" scoped>
.upload-demo {
    display: flex;
}
.processSearchTotal-collapse {
    margin: 6px 0;
}
</style>
